
import dataBaseClass from './dataBase.js';
export default class ado {
    constructor(parent,options){
        this.system = parent;
        this.db = parent.dbCom;                                             //服务端通讯模块对象
        this.RecordCurIndex = -1;                                       //记录集索引
        this.registerName = options.name;                               //后台组件名称
        this.connectString = options.config.connectString;              //关系库连接字串
        this.dataBase = new dataBaseClass(this.connectString);          //各关系库需要不同处理的函数集合
        this.defaultBaceName = this.dataBase.getDefaultDataBase(this.connectString);      //获取默认连接的数据库名称
        this.dataBase.initOptions(options);
        this.TableName = options.config.tableName;                      //默认连接的表名称
        this.isConnect = this.defaultBaceName ? true : false;           //是否已连接
        this.recordset = null;                                          //当前打开的记录集
        options.config.type = this.dataBase.type;
    }
    /*
        功能：获得连接串
    */
    async GetConnectStr (){
        return this.connectString;
    }
	/*
        功能：设置连接串
    */
	async SetConnectStr (connectStrting){
        console.warn("此版本暂不支持")
        //this.connectString = connectStrting;
        return false;
    }
    /*
        功能：打开数据库
        baceName ：数据库名称
    */
	async OpenDataBase (baceName){
        var openBaceName = baceName ? baceName : this.defaultBaceName;
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(additionalSql(this.registerName,"use " + openBaceName),(err,backResult)=>{
                if(err){
                    this.isConnect = false;
                    resolve(false);
                }else{
                    this.isConnect = true;
                    resolve(true);
                }
            })
        });
    }
	/*
        功能：关闭数据库
    */
	async CloseDataBase (){
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(additionalSql(this.registerName,"use master"),(err,backResult)=>{
                if(err){
                    resolve(false);
                }else{
                    this.isConnect = false;
                    resolve(true);
                }
            })
        });
    }
    /*
        功能：判断数据库是否打开
    */
	async DatabaseIsOpen (){
        return this.isConnect;
    }
    /*
        功能：获取最后错误
    */
	async GetLastErr (){
        console.warn("此版本暂不支持");
        return "";
    }
    /*
        功能：创建表
        tableName ： 表名称
        tableFieldList : 以逗号分隔的表字段名称字符串
        tableFieldTypeList ：以逗号分隔的表字段类型字符串
    */
	async CreateTable (tableName,tableFieldList,tableFieldTypeList){
        var nameArr = tableFieldList.split(",");
        var typeArr = tableFieldTypeList.split(",");
        if(nameArr.length != typeArr.length){
            return false;
        }
        var sql = "CREATE TABLE " + tableName + "(";
        for(var i = 0; i < nameArr.length;i++){
            sql += nameArr[i] + " " + typeArr[i] + ",";
        }
        sql += ")";
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(additionalSql(this.registerName,sql),(err,backResult)=>{
                if(err){
                    resolve(false);
                }else{
                    resolve(true);
                }
            })
        });
    }
    /*
        功能：删除指定表
        tableName ： 表名称 
    */
	async DeleteTable (tableName){
        var sql = "DROP TABLE " + tableName
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(additionalSql(this.registerName,sql),(err,backResult)=>{
                if(err){
                    resolve(false);
                }else{
                    resolve(true);
                }
            })
        });
    }
    /*
        功能：获取数据库所有的表名个数
    */
	async GetTablesCount (){
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(additionalSql(this.registerName,"select * from sys.tables"),(err,backResult)=>{
                if(err){
                    resolve(backResult);
                }else{
                    resolve(backResult.rowsAffected[0]);
                }
            })
        });
    }
    /*
        功能：获取数据表对应索引号的表名
        index:索引
    */
	async GetTableName (index){
        console.warn("此版本暂不支持");
        return false;
    }
    /*
        功能：通过指定SQL打开记录集recordset
    */
	async OpenRecordSet (SQLStr){
        this.lastSql = SQLStr;
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(additionalSql(this.registerName,SQLStr),(err,backResult)=>{
                if(err){
                    resolve(err);
                }else{
                    resolve(true);
                    this.RecordCurIndex = 0;
                    this.recordset = backResult.recordset;
                }
            })
        });
    }
    /*
        功能：执行SQL语句,执行结果放到recordset
    */
	async ExcuteSQL (SQLStr){
        this.lastSql = SQLStr;
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(additionalSql(this.registerName,SQLStr),(err,backResult)=>{
                if(err){
                    resolve(err);
                }else{
                    resolve(true);
                    this.RecordCurIndex = 0;
                    this.recordset = backResult.recordset;
                }
            })
        });
    }
    /*
        功能：sql语句格式化
    */
	async FilterSQL (SQLStr){
        return this.dataBase.FilterSQL(SQLStr);
    }
    /*
        功能：获取最后一条执行了的SQL语句
    */
	async GetLastSQL (){
        return this.lastSql;
    }
    /*
        功能：数据集是否打开
    */
	async RecordsetIsOpen (){
        return this.recordset ? true : false;
    }
    /*
        功能：关闭当前数据表
    */
	async CloseRecordset (){
        this.RecordCurIndex = -1;
        this.recordset = null;
        return true;
    }
    /*
        功能：获取数据表记录的条数
    */
	async GetRecordCount (){
        if(!this.recordset){
            alert("没有任何数据集被打开");
            return 0;
        }else{
            return this.recordset.length;
        }
    }
    /*
        功能：获取数据表的字段数
    */
	async GetFieldsCount (){
        if(!this.recordset){
            alert("没有任何数据集被打开");
            return 0;
        }else{
            var count = 0;
            for(var p in this.recordset[0]){
                count++;
            }
            return count;
        }
        
    }
    /*
        功能：获得相应索引号的字段（此版本暂不支持）
    */
	async GetFieldName (index){
        console.warn("此版本暂不支持");
        return false;
    }
    /*
        功能：新添加一条数据，配合PutValue系列方法使用
    */
	async AddNew (){
        this.newData = {}
        return 1;
    }
    /*
        功能：提交修改的数据，配合PutValue系列方法使用
    */
	async Update (){
        var sql = "INSERT INTO [" + this.TableName + "] (";
        for(var p in this.newData){
            sql += "[" + p + "],";
        }
        sql = sql.slice(0,sql.length-1);
        sql += ") VALUES (";
        for(var p in this.newData){
            sql += this._formatValue(this.newData[p]);
            sql += ",";
        }
        sql = sql.slice(0,sql.length-1);
        sql += ");";
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(additionalSql(this.registerName,sql),(err,backResult)=>{
                if(err){
                    resolve(err);
                }else{
                    resolve(true);
                    this.newData = undefined;
                }
            })
        });
    }
    /*
        功能：批量提交修改的数据（此版本暂不支持）
    */
	async UpdateBatch (){
        console.warn("此版本暂不支持");
        return false;
    }
    /*
        功能：删除指定的数据记录
    */
	async Delete (){
        this.recordset.splice(this.RecordCurIndex,1);
        var sql = "delete from " + this.TableName + "where "
        for(var p in this.recordset[this.RecordCurIndex]){
            sql += p;
            sql += "=";
            sql += this.recordset[this.RecordCurIndex][p];
            sql += " and " 
        }
        sql.slice(0,str.length-5);
        sql += ";";
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(additionalSql(this.registerName,sql),(err,backResult)=>{
                if(err){
                    resolve(err);
                }else{
                    resolve(true);
                    this.RecordCurIndex = 0;
                    this.recordset = backResult;
                }
            })
        });
    }
    /*
        功能：移动数据集游标到第一条位置
    */
	async MoveFirst (){
        if(!this.recordset){
            alert("没有任何数据集被打开");
            return false;
        }else{
            this.RecordCurIndex = 0;
            return true;
        }
    }
    /*
        功能：移动数据集游标到前一条位置
    */
	async MovePrevious (){
        if(!this.recordset){
            alert("没有任何数据集被打开");
            return false;
        }else{
            if(this.RecordCurIndex > 0){
                this.RecordCurIndex--;
            }
            return true;
        }
        
    }
    /*
        功能：移动数据集游标到后一条位置
    */
	async MoveNext (){
        if(!this.recordset){
            alert("没有任何数据集被打开");
            return false;
        }else{
            if(this.RecordCurIndex != -1){
                this.RecordCurIndex++;
            }
            return true;
        }
    }
    /*
        功能：移动数据集游标到最后一条位置
    */
	async MoveLast (){
        if(!this.recordset){
            alert("没有任何数据集被打开");
            return false;
        }else{
            this.RecordCurIndex = this.recordset.length - 1;
            return true;
        }
    }
    /*
        功能：移动数据集游标到指定位置
    */
	async Move (position){
        if(!this.recordset){
            alert("没有任何数据集被打开");
            return false;
        }else{
            if(position < 0) {
                return false;
            }
            this.RecordCurIndex = position;
            return true;
        }
        
    }
    /*
        功能：是否到达记录集尾部
    */
	async IsEOF (){
        if(!this.recordset){
            alert("没有任何数据集被打开");
            return false;
        }else{
            return this.RecordCurIndex != -1 && this.RecordCurIndex == this.recordset.length - 1 ? true:false;
        }
        
    }
    /*
        功能：是否到达记录集头部
    */
	async IsBOF (){
        if(!this.recordset){
            alert("没有任何数据集被打开");
            return false;
        }else{
            return this.RecordCurIndex == 0;
        }
    }
    /*
        功能：按照字段索引位置设定数据(int,double,string,time,file)（此版本暂不支持）
        index ： 索引
        value ： 值
    */
	async PutValueByIndexInt (index,value){
        console.warn("此版本暂不支持");
        return false;
    }
	async PutValueByIndexDouble (index,value){
        console.warn("此版本暂不支持");
        return false;
    }
	async PutValueByIndexStr (index,value){
        console.warn("此版本暂不支持");
        return false;
    }
	async PutValueByIndexTime (index,value){
        console.warn("此版本暂不支持");
        return false;
    }
	async PutValueByIndexFile (index,fileName){
        console.warn("此版本暂不支持");
        return false;
    }
    /*
        功能：按照字段名称设定数据(int,double,string,time,file)
        field ： 字段名
        value ： 值
    */
	async PutValueByFieldInt (field,value){
        this.newData[field] = {
            type : "INT",
            value : value
        }
    }
	async PutValueByFieldDouble (field,value){
        this.newData[field] = {
            type : "DOUBLE",
            value : value
        }
    }
	async PutValueByFieldStr (field,value){
        this.newData[field] = {
            type : "VARCHAR",
            value : value
        }
    }
	async PutValueByFieldTime (field,value){
        this.newData[field] = {
            type : "TIME",
            value : value
        }
    }
	async PutValueByFieldFile (field,FileName){
        console.warn("此版本暂不支持");
        return false;
    }
    /*
        功能：按照字段索引位置获取(int,double,string,time,file)（此版本暂不支持）
        index ： 索引
    */
	async GetValueByIndexInt (index){
        console.warn("此版本暂不支持");
        return false;
    }
	async GetValueByIndexDouble (index){
        console.warn("此版本暂不支持");
        return false;
    }
	async GetValueByIndexStr (index){
        console.warn("此版本暂不支持");
        return false;
    }
	async GetValueByIndexTime (index){
        console.warn("此版本暂不支持");
        return false;
    }
	async GetValueByIndexFile (index){
        console.warn("此版本暂不支持");
        return false;
    }
    /*
        功能：按照字段名称获取(int,double,string,time,file)
        field ： 字段名
    */
	async GetValueByFieldInt (field){
        if(this.recordset){
            if(this.recordset.length >0){
                this.RecordCurIndex = this.RecordCurIndex == -1 ? 0 : this.RecordCurIndex;
                var aa = this.recordset[this.RecordCurIndex][field]
                return aa;
            }else{
                return -9999;
            }
        }else{
            return -9999;
        }
        
    }
	async GetValueByFieldDouble (field){
        if(this.recordset){
            if(this.recordset.length >0){
                this.RecordCurIndex = this.RecordCurIndex == -1 ? 0 : this.RecordCurIndex;
                return this.recordset[this.RecordCurIndex][field];
            }else{
                return -9999.0000;
            }   
        }else{
            return -9999.0000;
        }
    }
	async GetValueByFieldStr (field){
        if(this.recordset){
            if(this.recordset.length >0){
                this.RecordCurIndex = this.RecordCurIndex == -1 ? 0 : this.RecordCurIndex;
                return this.recordset[this.RecordCurIndex][field];
            }else{
                return "error";
            }
        }else{
            return "error";
        }
    }
	async GetValueByFieldTime (field){
        if(this.recordset){
            this.RecordCurIndex = this.RecordCurIndex == -1 ? 0 : this.RecordCurIndex;
            return new Date(this.recordset[this.RecordCurIndex][field]).getTime();
        }else{
            return new Date("1980-1-1 00:00:00").getTime();
        }
    }
	async GetValueByFieldFile (field,fileName){
        console.warn("此版本暂不支持");
        return false;
    }
    /*
        功能：根据SQL数据表模板创建表（此版本暂不支持）
    */
	async CreateTableEx (TableName,TemplateName){
        console.warn("此版本暂不支持");
        return false;
    }
    /*
        功能：获取数据（此版本暂不支持）
    */
	async GetData (BindName){
        console.warn("此版本暂不支持");
        return false;
    }
    /*
        功能：设置数据（此版本暂不支持）
    */
	async SetData (BindName){
        console.warn("此版本暂不支持");
        return false;
    }

    _formatValue(obj){
        switch(obj.type){
            case "VARCHAR":
                return "'" + obj.value + "'";
            default:
                return obj.value;
        }
    }
}
/*
    功能：附加sql语句到报文。私有函数，外部不可对报文进行修改
*/
var additionalSql = function(name,sql){
    return {
        head : "backstage",
        message : {
            head : "fvADOModule",
            type : "api",
            message : {
                name : name,
                sql : sql
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/backstage/fvADOModule/index.js